export default __webpack_public_path__ + "static/media/deeperInsightsColored.2f81f5df.svg";